import { render, staticRenderFns } from "./InstitutionInfo.vue?vue&type=template&id=1d365794&scoped=true&"
import script from "./InstitutionInfo.vue?vue&type=script&lang=ts&"
export * from "./InstitutionInfo.vue?vue&type=script&lang=ts&"
import style0 from "./InstitutionInfo.vue?vue&type=style&index=0&id=1d365794&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d365794",
  null
  
)

export default component.exports